import React, { useEffect, useState } from 'react';
import { Button } from '../ui/Button';
import { useTranslation } from '../../lib/i18n';
export function CookieBanner() {
  const {
    lang
  } = useTranslation();
  const en = lang === 'en';
  const ru = lang === 'ru';
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const consent = localStorage.getItem('dtech_cookie_consent');
    if (!consent) {
      // Small delay so it doesn't pop up instantly
      const timer = setTimeout(() => setIsVisible(true), 1000);
      return () => clearTimeout(timer);
    }
  }, []);
  const handleAccept = () => {
    localStorage.setItem('dtech_cookie_consent', 'true');
    setIsVisible(false);
  };
  if (!isVisible) return null;
  return <div className="fixed bottom-0 left-0 right-0 z-50 p-4 bg-dark-surface border-t border-dark-border shadow-[0_-10px_30px_rgba(0,0,0,0.5)] animate-fade-in" data-id="element-339" data-mp="1eiz7vnzll89e">
      <div className="max-w-6xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-4" data-id="element-340" data-mp="270bm2upuqzf5">
        <div className="text-sm text-gray-300 text-center sm:text-left" data-id="element-341" data-mp="ztckunm14civ">
          {en ? <>
              We use cookies to improve your experience on our website. By
              continuing to browse, you agree to our use of cookies.
            </> : ru ? <>
              Мы используем файлы cookie для улучшения вашего опыта на нашем
              сайте. Продолжая просмотр, вы соглашаетесь с использованием файлов
              cookie.
            </> : <>
              Koristimo kolačiće kako bismo poboljšali vaše korisničko iskustvo.
              Nastavkom korišćenja sajta slažete se sa upotrebom kolačića.
            </>}
        </div>
        <div className="flex gap-3 flex-shrink-0" data-id="element-342" data-mp="1nk87z7fjijjs">
          <Button variant="primary" size="sm" onClick={handleAccept} data-id="element-343" data-mp="1nhcblnjcc2xg">
            {en ? 'Accept' : ru ? 'Принять' : 'Prihvatam'}
          </Button>
        </div>
      </div>
    </div>;
}